import { render } from "./SuspendedContract.vue?vue&type=template&id=47f1084f&scoped=true"
import script from "./SuspendedContract.vue?vue&type=script&lang=js"
export * from "./SuspendedContract.vue?vue&type=script&lang=js"

import "./SuspendedContract.vue?vue&type=style&index=0&id=47f1084f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47f1084f"

export default script